import React from 'react';

import { getSectionId } from '../utils/getters';

export default function Anchor({ section, id }) {
  return <div id={id || getSectionId(section)} className="anchor" />;
}
